export default class TimesheetsSummaryCandidateViewModel {
  constructor({
    candidateId = 0,
    candidateName = '',
    approvedCount = 0,
    pendingReviewCount = 0,
    pendingApprovalCount = 0,
  } = {}) {
    /**
     * @type {Number}
     */
    this.candidateId = candidateId
    /**
     * @type {String}
     */
    this.candidateName = candidateName
    /**
     * @type {Number}
     */
    this.approvedCount = approvedCount
    /**
     * @type {Number}
     */
    this.pendingReviewCount = pendingReviewCount
    /**
     * @type {Number}
     */
    this.pendingApprovalCount = pendingApprovalCount
  }
}
